import QuoteSpotWrapper from "@components/layouts/quoteSpotWrapper";
import CategoryForm from "@components/quotespot/categoryForm";
import WhyQuoto from "@components/quotespot/whyQuoto";
import { useDomainContext } from "@hooks/useDomainContext";
import { getPageProps } from "@services/initial-calls";
import { GetServerSideProps } from "next";
import React, { ReactElement } from "react";
import OffersList from "@components/shared/offersList";
export default function QuotoCategoryPage(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <QuoteSpotWrapper>
            <CategoryForm />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyQuoto />
        </QuoteSpotWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "category");
};
